import React, { Component } from "react";
import { observer } from "mobx-react";
import { clearInterval, setInterval } from "worker-timers";

import { duration } from "@formant/core/model/duration";

import { appStore, operateStore } from "../../stores";
import { localSettingObservable } from "../../utils/localSettingObservable";
import { Hotkey } from "../common/hotkey/Hotkey";
import { IStandardButtonProps, StandardButton } from "../common/StandardButton";
import * as styles from "./ExitButton.scss";

export interface IExitButtonProps extends IStandardButtonProps {
    onWillExitSoon?: (willExitSoon: boolean) => void;
    onExit: (timedOut: boolean) => void;
}

function millsecondsToMinutes(millseconds: number) {
    const minutes = Math.floor(millseconds / duration.minute);
    const seconds = Math.floor(
        (millseconds % duration.minute) / duration.second,
    );
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
}

const maxTime = duration.minute * 4;
@observer
export class ExitButton extends Component<IExitButtonProps> {
    @localSettingObservable("simulator-countdown-seconds")
    time: number | undefined;

    intervalHandle: number | undefined;

    componentDidMount() {
        const { onWillExitSoon } = this.props;
        const { preview } = appStore;
        if (preview) {
            this.time = this.time !== undefined ? this.time : maxTime;
        }
        const timeReduction = duration.millisecond * 30;
        this.intervalHandle = setInterval(() => {
            if (this.time && !operateStore.editingDevice && !appStore.sharing) {
                this.time -= timeReduction;
            }
            if (
                onWillExitSoon &&
                this.time !== undefined &&
                this.time <= duration.second * 30
            ) {
                onWillExitSoon(true);
            }
            if (this.time !== undefined && this.time <= 0) {
                operateStore.armSwitchEnabled = false;
                this.props.onExit(true);
                this.time = undefined;
            }
        }, timeReduction);
    }

    componentWillUnmount(): void {
        if (this.intervalHandle) {
            clearInterval(this.intervalHandle);
            this.time = undefined;
        }
    }

    public render() {
        const { onNormalExit } = this;

        return (
            <>
                <div
                    className={styles["rainbow-timer"]}
                    style={{
                        width: this.time
                            ? `${(this.time / maxTime) * 100}%`
                            : "0%",
                    }}
                />
                <StandardButton
                    className={styles["exit-button"]}
                    onClicked={onNormalExit}
                    critical={true}
                >
                    <Hotkey
                        code="shift+esc"
                        label="Exit session"
                        onHotkey={onNormalExit}
                    />
                    <span className={styles.unhovered}>
                        {this.time !== undefined
                            ? " " + millsecondsToMinutes(this.time)
                            : "Exit"}
                    </span>
                    <span className={styles.hovered}>Exit</span>
                </StandardButton>
            </>
        );
    }

    onNormalExit = () => {
        this.props.onExit(false);
    };
}
